import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios-auth'
import { setStore, getStore, removeItem } from '@/config/utils';
import { gateway } from "@/store/modules/gateway";

Vue.prototype.$http = axios
Vue.use(Vuex);

export default new Vuex.Store({

    modules: {
        gateway
    },

    state: {
        loading: undefined,
        loginUser: null
    },

    getters: {
        getLoading(state){
            console.log('getLoading',state.loading)
            return state.loading
        }
    },

    mutations: {
        setLoading(state, request) {
            console.log('setLoading',request)
            state.loading = request
        },
        setLoginUser(state, user) {
            state.loginUser = user
            setStore('user', user)
        },
        setLogout(state) {
            state.loginUser = null
            removeItem('user')
        }
    },

    actions: {
        serviceLoading(context, request) {
            console.log('serviceLoading',request)
            context.commit('setLoading', request)
        },
        logout({ commit }) {
            commit('setLogout')
        },
    }
});
